import { Phone, MessageCircle, MapPin, Clock, Mail } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "./ui/button";

export default function ContactSection() {
  const { t, settings, L } = useApp();
  const c = settings?.contact || {};

  const items = [
    { icon: Phone, label: c.phone, href: c.phone ? `tel:${c.phone}` : null, dir: "ltr" },
    { icon: MessageCircle, label: "WhatsApp", href: c.whatsapp ? `https://wa.me/${c.whatsapp}` : null },
    { icon: MapPin, label: L(c, "location"), href: c.map_url },
    { icon: Clock, label: L(c, "hours"), href: null },
    { icon: Mail, label: c.email, href: c.email ? `mailto:${c.email}` : null, dir: "ltr" },
  ].filter((x) => x.label);

  return (
    <section className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 sm:py-24" data-testid="contact-section">
      <div className="rounded-3xl cb-gradient overflow-hidden relative">
        <div className="absolute -top-16 -end-16 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
        <div className="relative p-8 sm:p-14 grid lg:grid-cols-2 gap-10 text-primary-foreground">
          <div>
            <h2 className="font-display text-3xl sm:text-4xl font-bold">{t.home.contactTitle}</h2>
            <p className="mt-3 text-lg opacity-90">{t.home.contactSub}</p>
            <div className="mt-8 space-y-4">
              {items.map((it, i) => {
                const Inner = (
                  <span className="flex items-center gap-3">
                    <span className="grid place-items-center h-11 w-11 rounded-2xl bg-white/15">
                      <it.icon className="h-5 w-5" />
                    </span>
                    <span className="font-medium" dir={it.dir}>{it.label}</span>
                  </span>
                );
                return it.href ? (
                  <a key={i} href={it.href} target="_blank" rel="noopener noreferrer" className="block hover:opacity-90 transition-opacity" data-testid={`contact-item-${i}`}>
                    {Inner}
                  </a>
                ) : (
                  <div key={i} data-testid={`contact-item-${i}`}>{Inner}</div>
                );
              })}
            </div>
          </div>
          <div className="grid place-items-center">
            <div className="cb-glass rounded-3xl p-8 text-center w-full max-w-sm text-foreground">
              <h3 className="text-xl font-bold">{t.nav.book}</h3>
              <p className="text-muted-foreground mt-2 text-sm">{t.services.subtitle}</p>
              <Button asChild className="mt-6 rounded-full w-full h-12 font-bold">
                <a href="/book" data-testid="contact-book-cta">{t.common.bookNow}</a>
              </Button>
              {c.whatsapp && (
                <Button asChild variant="outline" className="mt-3 rounded-full w-full h-12 font-semibold border-2">
                  <a href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noopener noreferrer">
                    <MessageCircle className="h-5 w-5 me-2" /> WhatsApp
                  </a>
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
